import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '../store/auth'

const ResourcePage = () => import('../views/ResourcePage.vue')

export const routes: RouteRecordRaw[] = [
  { path: '/login', name: 'login', component: () => import('../views/Login.vue') },
  {
    path: '/',
    component: () => import('../layouts/AdminLayout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: { title: '首页驾驶舱', icon: 'Monitor', permission: 'dashboard:read' }
      },
      {
        path: 'park',
        name: 'park',
        component: () => import('../views/ParkMaterials.vue'),
        meta: { title: '园区资料管理', icon: 'OfficeBuilding', permission: 'park:read' }
      },
      {
        path: 'parcels',
        name: 'parcels',
        component: ResourcePage,
        meta: { title: '地块资源管理', icon: 'Map', permission: 'parcels:read', resource: 'parcels' }
      },
      {
        path: 'enterprises',
        name: 'enterprises',
        component: ResourcePage,
        meta: {
          title: '企业管理',
          icon: 'Briefcase',
          permission: 'enterprises:read',
          resource: 'enterprises'
        }
      },
      {
        path: 'projects',
        name: 'projects',
        component: ResourcePage,
        meta: { title: '在建项目管理', icon: 'DataLine', permission: 'projects:read', resource: 'projects' }
      },
      {
        path: 'investment-resources',
        name: 'investment-resources',
        component: ResourcePage,
        meta: {
          title: '招商资源管理',
          icon: 'TrendCharts',
          permission: 'investment-resources:read',
          resource: 'investmentResources'
        }
      },
      {
        path: 'public-facilities',
        name: 'public-facilities',
        component: ResourcePage,
        meta: {
          title: '公共配套管理',
          icon: 'Location',
          permission: 'public-facilities:read',
          resource: 'publicFacilities'
        }
      },
      {
        path: 'model-resources',
        name: 'model-resources',
        component: ResourcePage,
        meta: {
          title: '三维模型资源管理',
          icon: 'Box',
          permission: 'model-resources:read',
          resource: 'modelResources'
        }
      },
      {
        path: 'map-layers',
        name: 'map-layers',
        component: ResourcePage,
        meta: { title: '地图图层管理', icon: 'Files', permission: 'map-layers:read', resource: 'mapLayers' }
      },
      {
        path: 'camera-points',
        name: 'camera-points',
        component: ResourcePage,
        meta: {
          title: '视频监控点位管理',
          icon: 'VideoCamera',
          permission: 'camera-points:read',
          resource: 'cameraPoints'
        }
      },
      {
        path: 'camera-grid',
        name: 'camera-grid',
        component: () => import('../views/CameraGrid.vue'),
        meta: { title: '九宫格点位配置', icon: 'Grid', permission: 'camera-points:update' }
      },
      {
        path: 'tour-routes',
        name: 'tour-routes',
        component: ResourcePage,
        meta: { title: '漫游路线管理', icon: 'Guide', permission: 'tour-routes:read', resource: 'tourRoutes' }
      },
      {
        path: 'attachments',
        name: 'attachments',
        component: () => import('../views/Attachments.vue'),
        meta: { title: '资料附件管理', icon: 'Paperclip', permission: 'files:read' }
      },
      {
        path: 'users',
        name: 'users',
        component: () => import('../views/UserManagement.vue'),
        meta: { title: '用户管理', icon: 'User', permission: 'system:read' }
      },
      {
        path: 'roles',
        name: 'roles',
        component: () => import('../views/RolePermission.vue'),
        meta: { title: '角色权限管理', icon: 'Lock', permission: 'system:read' }
      },
      {
        path: 'operation-logs',
        name: 'operation-logs',
        component: () => import('../views/OperationLogs.vue'),
        meta: { title: '操作日志', icon: 'Document', permission: 'system:read' }
      },
      {
        path: 'settings',
        name: 'settings',
        component: () => import('../views/SystemSettings.vue'),
        meta: { title: '系统配置', icon: 'Setting', permission: 'system:read' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  if (to.path === '/login') return true
  if (!auth.isAuthed) return `/login?redirect=${encodeURIComponent(to.fullPath)}`
  if (!auth.user) await auth.fetchMe()
  if (!auth.can(to.meta.permission as string | undefined)) return '/dashboard'
  return true
})

export default router

